import { useState, useEffect } from 'react'
import { type SelectItemType } from './index'

export function useMaxOptionWidth(items: Array<SelectItemType> | undefined, enabled = true): string | undefined {
  const [maxWidth, setMaxWidth] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!enabled || !items || items.length === 0) {
      setMaxWidth(undefined)
      return
    }

    const measureContainer = document.createElement('div')
    measureContainer.style.position = 'absolute'
    measureContainer.style.visibility = 'hidden'
    measureContainer.style.whiteSpace = 'nowrap'
    measureContainer.style.font = 'inherit'
    measureContainer.style.fontSize = '1rem'
    measureContainer.style.fontWeight = '500'
    measureContainer.style.lineHeight = '1.5rem'

    document.body.appendChild(measureContainer)

    let maxOptionWidth = 0

    for (const item of items) {
      const textSpan = document.createElement('span')
      textSpan.textContent = item.label

      const wrapper = document.createElement('div')
      wrapper.style.display = 'flex'
      wrapper.style.alignItems = 'center'
      wrapper.style.gap = '0.5rem'

      if (item.icon) {
        const iconPlaceholder = document.createElement('div')
        iconPlaceholder.style.width = '16px'
        iconPlaceholder.style.height = '16px'
        wrapper.appendChild(iconPlaceholder)
      }

      wrapper.appendChild(textSpan)
      measureContainer.appendChild(wrapper)

      const width = wrapper.getBoundingClientRect().width
      maxOptionWidth = Math.max(maxOptionWidth, width)

      measureContainer.removeChild(wrapper)
    }

    document.body.removeChild(measureContainer)

    const totalWidth = Math.ceil(maxOptionWidth + 32 + 16 + 12 + 8)
    const remWidth = totalWidth / 16
    setMaxWidth(`${remWidth}rem`)
  }, [items, enabled])

  return maxWidth
}
